<template>
  <li class="tree-node" :class="{expanded: isExpanded, selected: isSelected}">
    <div>
      <div
        class="expander"
        @click="toggleExpand"
        :class="{expanded: treeNodeData.expanded, loading: isLoading, hidden: treeNodeData[leafField] || (treeNodeData.children && treeNodeData.children.length === 0)}"
      ></div>
      <div class="label" @click="onSelect" @dblclick="onDoubleClick">{{treeNodeData[labelField]}}</div>
    </div>
    <ul v-if="hasChildren">
      <TreeNode
        v-for="child in treeNodeData.children"
        :key="child[valueField]"
        :data="child"
        :labels="labelField"
        :values="valueField"
        :root="treeRoot"
        :dataFnc="dataFnc"
        :leaf="leafField"
      ></TreeNode>
    </ul>
  </li>
</template>

<script>
export default {
  name: "TreeNode",
  props: [
    "data",
    "dataFnc",
    "value",
    "labels",
    "values",
    "expanded",
    "selected",
    "root",
    "leaf"
  ],
  data() {
    return {
      treeNodeData: this.data,
      labelField: this.labels || "name",
      valueField: this.values || "id",
      leafField: this.leaf || "isLeaf",
      isExpanded: this.expanded || false,
      isSelected: this.selected || false,
      treeRoot: this.root || this,
      hasChildren: this.data.children && this.data.children.length > 0,
      isLoading: false
    };
  },
  mounted() {
    this.isExpanded = this.expanded || false;
    this.treeRoot.$on("change", e => {
      if (this.isSelected && this.treeNodeData[this.valueField] !== e.value) {
        this.isSelected = false;
      }
    });
  },
  methods: {
    toggleExpand() {
      if (this.isLoading) return;
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded && !this.treeNodeData.children && this.dataFnc) {
        this.isLoading = true;
        this.dataFnc(this.treeNodeData[this.valueField])
          .then(res => {
            this.treeNodeData.children = res;
            this.hasChildren = res && res.length > 0;
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;
            console.error(err);
          });
      }
    },
    onSelect() {
      if (!this.isSelected) {
        this.isSelected = true;
        this.treeRoot.$emit("change", {
          sender: this,
          value: this.treeNodeData[this.valueField],
          label: this.treeNodeData[this.labelField]
        });
      }
    },
    onDoubleClick() {
      if (!this.isSelected) {
        this.isSelected = true;
      }
      this.treeRoot.$emit("dblclick", {
        sender: this,
        value: this.treeNodeData[this.valueField],
        label: this.treeNodeData[this.labelField]
      });
    }
  },
  watch: {
    selected(val) {
      this.isSelected = val;
    }
  }
};
</script>

<style scoped>
.tree-node {
  padding-left: 16px;
}

.tree-node > div {
  display: flex;
  align-items: center;
}

.tree-node > div > div.label:hover,
.tree-node.selected > div > div.label {
  background-color: #f5f5f5;
  outline: 1px solid #dddddd;
}

.tree-node > div > div.label {
  padding: 2px;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}

.tree-node > div > div.expander {
  width: 10px;
  height: 10px;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='255' height='255' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Ctitle%3Ebackground%3C/title%3E%3Crect fill='none' id='canvas_background' height='402' width='582' y='-1' x='-1'/%3E%3C/g%3E%3Cg%3E%3Ctitle%3ELayer 1%3C/title%3E%3Cg transform='rotate(-90 127.50000000000001,127.50000000000001) ' id='svg_1'%3E%3Cg id='arrow-drop-down'%3E%3Cpolygon id='svg_2' points='0,63.75 127.5,191.25 255,63.75'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-size: 10px 10px;
  margin-right: 5px;
  cursor: pointer;
}

.tree-node.expanded > div > div.expander {
  width: 10px;
  height: 10px;
  background-image: url("data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='iso-8859-1'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='255px' height='255px' viewBox='0 0 255 255'%3E%3Cg%3E%3Cg id='arrow-drop-down'%3E%3Cpolygon points='0,63.75 127.5,191.25 255,63.75'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-size: 10px 10px;
  margin-right: 5px;
  cursor: pointer;
}

.tree-node.expanded > div > div.expander.loading {
  width: 15px;
  height: 25px;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg class='lds-spinner' width='32px' height='32px' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid' style='background: none;'%3E%3Cg transform='rotate(0 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='@000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.9166666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(30 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='@000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.8333333333333334s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(60 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='@000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.75s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(90 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='@000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.6666666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(120 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='@000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.5833333333333334s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(150 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='@000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.5s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(180 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='@000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.4166666666666667s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(210 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='@000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.3333333333333333s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(240 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='@000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.25s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(270 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='@000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.16666666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(300 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='@000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.08333333333333333s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(330 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='@000'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='0s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3C/svg%3E");
  background-size: 25px 25px;
  margin-right: 5px;
  cursor: pointer;
  background-position-x: -5px;
  margin-left: -5px;
}

.tree-node > div > div.expander.hidden {
  background-image: none;
  cursor: default;
  /*margin-left: 16px;*/
}

.tree-node > ul {
  display: none;
}

.tree-node.expanded > ul {
  display: block;
}
</style>